import { StoreContext, UserStore, CompanyDropdownStore  } from '@roc/feature-app-core';
import { useContext } from 'react';

export const useUserStore = () =>
  useContext<{
    userStore: UserStore;
    companyDropdownStore: CompanyDropdownStore;
  }>(StoreContext);
